export default function StatusBadge({ status }) {
  const map = {
    ativo:        ['badge-ativo',      'Ativo'],
    inativo:      ['badge-inativo',    'Inativo'],
    aprovado:     ['badge-aprovado',   'Aprovado'],
    vencido:      ['badge-vencido',    'Vencido'],
    reprovado:    ['badge-vencido',    'Reprovado'],
    agendado:     ['badge-agendado',   'Agendado'],
    finalizado:   ['badge-inativo',    'Finalizado'],
    em_analise:   ['badge-agendado',   'Em análise'],
    confirmado:   ['badge-aprovado',   'Confirmado'],
    recusado:     ['badge-vencido',    'Recusado'],
    standby:      ['badge-inativo',    'Standby'],
    refazer:      ['badge-vencido',    'Refazer'],
    cancelado:    ['badge-inativo',    'Cancelado'],
  };
  const [cls, label] = map[status?.toLowerCase()] || ['badge-inativo', status || '—'];
  return <span className={`badge rounded-pill ${cls}`}>{label}</span>;
}
